$(document).ready(function() {
    $(".cta").click(function() {
        $(".cta-modal").fadeToggle(100);
        localStorage.setItem("cta-modal", true);

        if(localStorage.getItem("cta-modal") == true) {
            $(".cta-modal").style.display = 'block';
            localStorage.setItem("cta-modal", true);
        } else {
            $(".cta-modal").style.display = 'none';
            localStorage.setItem("cta-modal", false);
        }
    });
});

$(document).ready(function() {
    if (localStorage.getItem('maindark') == 'dark') {
        $('#main').addClass('dark-main');
        $('#hero').removeClass('light-hero');
        $('#hero').addClass('dark-hero');
        $('#foot').removeClass('light-footer');
        $('#foot').addClass('dark-footer');
    }

    var mode_switch = document.getElementById('dark-switch').check;
    // console.log("Mode_switch: " + mode_switch);

    if (mode_switch == false) {
        // console.log('checking mode');
        var checked_local = localStorage.getItem('dark-switch-mode');
        // console.log("Local Storage: " + localStorage.getItem('dark-switch-mode'));
        if (checked_local == 'true' || checked_local == true) {
            $('#dark-switch').prop('checked', true);
        } else {
            document.getElementById("dark-switch").check = false;
        }
    } else {
        document.getElementById("dark-switch").check = false;
    }
    
    console.log(mode_switch);

    $('#dark-switch').change(function() {
        console.log('Changed');
        if($(this).is(":checked")) {
            $('#main').addClass('dark-main');

            $('#hero').removeClass('light-hero');
            $('#hero').addClass('dark-hero');

            $('#foot').removeClass('light-footer');
            $('#foot').addClass('dark-footer');
            localStorage.setItem('maindark', 'dark');
            localStorage.setItem('herodark', 'dark');
            localStorage.setItem('footdark', 'dark');
            localStorage.setItem("dark-switch-mode", true);
        } else {
            $('#main').removeClass('dark-main');

            $('#hero').removeClass('dark-hero');
            $('#hero').addClass('light-hero');

            $('#foot').removeClass('dark-footer');
            $('#foot').addClass('light-footer');
            localStorage.setItem('maindark', 'light');
            localStorage.setItem('herodark', 'light');
            localStorage.setItem('footdark', 'light');
            localStorage.setItem("dark-switch-mode", false);
        }
    });
});



document.getElementById("submit-btn").addEventListener("click",sendMail);
function sendMail() {
    // emailjs.init("user_I4LWK44JdoNbYYfwVIbPJ");

    var sender_name = document.getElementById("sender_name").value;
    var sender_mail = document.getElementById("sender_email").value;
    var sender_mssg = document.getElementById("message").value;

    if(sender_mssg == "") {
        sender_mssg = "No Message Provided.";
    }

    var templateParams = {
        from_name: sender_name,
        sender_mail: sender_mail,
        message: sender_mssg
    };

    emailjs.send('service_mul0lgh', 'template_yzabdsh', templateParams)
    .then(function(response) {        
        console.log('SUCCESS!', response.status, response.text);
        document.getElementById("sender_name").value = "";
        document.getElementById("sender_email").value = "";
        document.getElementById("message").value = "";
        document.getElementById("success-msg").style.opacity = 1;
    }, function(error) {
       console.log('FAILED...', error);
       document.getElementById("fail-msg").style.opacity = 1;
    });
}
